import * as React from 'react';
import {
	Create,
	CreateProps,
	SelectInput,
	SimpleForm,
	TextInput
} from 'react-admin';
import { EDayOfWeek, ELanguage } from '../enums';
import TimeInput from "../components/TimeInput";

export const LiveTrainingCreate = (props: CreateProps): React.ReactElement => {
	return (
		<Create {...props}>
			<SimpleForm>
				<TextInput source="title" label="TITLE"/>
				<SelectInput source="dayOfWeek" label="DAY" emptyValue={null} emptyText="" choices={[{id: null, name: ''} , ...Object.keys(EDayOfWeek).map(key => ({
					id: EDayOfWeek[key],
					name: EDayOfWeek[key]
				}))]}/>
				<TimeInput source="startHour" label="START_HOUR"/>
				<TimeInput source="endHour" label="END_HOUR"/>
				<TextInput type="url"  source="link" label="LINK"/>
				<SelectInput source="language" label="LANGUAGE" emptyValue={null} emptyText="" choices={[{id: null, name: ''} , ...Object.keys(ELanguage).map(key => ({
					id: ELanguage[key],
					name: ELanguage[key]
				}))]}/>
			</SimpleForm>
		</Create>
	);
};
